(ns lupapalvelu.ui2.radio
  (:require ["@base-ui/react/radio" :refer [Radio]]
            ["@base-ui/react/radio-group" :refer [RadioGroup]]
            ["react" :as react]
            [lupapalvelu.ui2.variant-builder :refer [builder merge-props-classes]]
            [reagent.core :refer [defc]]
            [reagent.hooks :as hooks]))

;; Base-UI used for aria property handling etc.

(def variants
  {:base     {:group     []
              :label     ["flex items-center gap-2 text-sm font-normal text-text-lightbg"
                          "group"]
              :root      ["flex shrink-0 items-center justify-center border rounded-full p-0"
                          "border-primary bg-input-fill-enabled text-state-enabled-fill-primary"
                          "data-checked:border-2"
                          ;; Label hover affects radio color
                          "group-hover:border-primary/70"
                          ;; Label hover, checked radio
                          "data-checked:group-hover:text-state-enabled-fill-primary data-checked:group-hover:border-state-hover-stroke-tertiary"
                          ;; Disabled state, important to go ensure this is used over hover color
                          "data-disabled:border-state-disabled-stroke-secondary! data-disabled:bg-state-disabled-fill-tertiary! data-disabled:text-text-disabled!"
                          ;; Focus indicator
                          "focus-visible:outline-2 focus-visible:outline-input-stroke-focus"]
              :indicator ["flex items-center justify-center data-unchecked:hidden before:size-(--icon-size) before:rounded-full "
                          ;; Follow text color from root element
                          "before:bg-current"]}
   ;; TODO: Size variants?
   :defaults {:size :md}
   :variants {:disabled {true {:label ["text-ui-neutral-mid"]}}
              :size     {:sm {:root ["size-[16px] [--icon-size:8px]"]}
                         :md {:root ["size-[24px] [--icon-size:12px]"]}
                         :lg {:root ["size-[32px] [--icon-size:16px]"]}
                         :xl {:root ["size-[40px] [--icon-size:20px]"]}}}})

(def classes
  (builder variants))

(def RadioRoot (.-Root Radio))
(def RadioIndicator (.-Indicator Radio))

(def RadioGroupContext (react/createContext {}))

(defc radio [props & children]
  (let [group-disabled (:disabled (hooks/use-context RadioGroupContext))
        props          (merge {:disabled group-disabled}
                              props)]
    (into [:label
           (merge-props-classes (:label-props props)
                                (classes props :label))
           [:> RadioRoot (merge-props-classes (dissoc props :label-props)
                                              (classes props :root))
            [:> RadioIndicator {:class (classes props :indicator)}]]]
          children)))

(defn radio-group [props & children]
  [:> RadioGroup
   (merge-props-classes props (classes props :group))
   (into [:r> RadioGroupContext #js {:value {:disabled (:disabled props)}}]
         children)])
